/**
 * Gets the appropriate CSS class for a score based on its value
 * Higher scores get darker blue backgrounds
 * @param {number} score - The score to determine color for
 * @returns {string} - CSS classes for the score
 */
export const getScoreColor = (score) => {
  if (score >= 95) return 'bg-blue-900 text-white';
  if (score >= 90) return 'bg-blue-800 text-white';
  if (score >= 85) return 'bg-blue-700 text-white';
  if (score >= 80) return 'bg-blue-600 text-white';
  if (score >= 75) return 'bg-blue-500 text-white';
  if (score >= 70) return 'bg-blue-400 text-black';
  if (score >= 65) return 'bg-blue-300 text-black';
  if (score >= 60) return 'bg-blue-200 text-black';
  return 'bg-blue-100 text-black';
};

/**
 * Determines text color class based on a score
 * Used for text-only displays without backgrounds
 * @param {number} score - The score value
 * @returns {string} - The CSS class for the text color
 */
export const getScoreTextColor = (score) => {
  if (score >= 90) return 'text-blue-700';
  if (score >= 80) return 'text-blue-500';
  return 'text-gray-600';
};

/**
 * Gets special styling for ASI model (red instead of blue)
 * @param {number} score - The score value
 * @returns {string} - The CSS class for ASI model highlighting
 */
export const getASIModelColor = (score) => {
  if (score >= 90) return 'bg-red-700 text-white';
  if (score >= 85) return 'bg-red-600 text-white';
  if (score >= 80) return 'bg-red-500 text-white';
  if (score >= 75) return 'bg-red-400 text-white';
  return 'bg-red-300 text-black';
};
